/**
 * @author xiaohuangmao
 * @date 2021-02-19
 * @desc 受众组查看
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { getDetailRecord } from "@/utils/commonUtils";
import { Descriptions } from "antd";
import { AudienceGroupItem } from '@/components';
import "./index.less";

const { WizCard, WizSpin} = component_tool;
const { WizContainer, modelUtils } = framework_tool;

class AudienceGroupPreview extends WizContainer {
  componentName = "AudienceGroupPreview";

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history, "/audience/group/preview");
    this.state = {
      managerScope: {}
    }
  }

  _componentDidMount() {
    this.doAction({
      path: "audienceGroup/editInfo",
      payload: {
        key: "audienceGroup@editInfo",
        apiParams: { id: this.detailInfo.id },
      },
    });
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    editInfo: this._editInfo.bind(this),
  };

  _editInfo(nextProps, nextState) {
    const { editInfo } = nextProps;
    if (editInfo["success"] && editInfo["data"]) {
      nextState.managerScope = editInfo.data.managerScope
      return true;
    }
    wizNotice.error(editInfo.msg)
    return false;
  }

  renderItems = () => {
    const { managerScope } = this.state
    const { name, intro, groupScope } = this.detailInfo;
    const arr = [
      { label: "名称", value: name },
      { label: "受众组", value: <AudienceGroupItem { ...groupScope } /> },
      { label: "管理范围", value: <AudienceGroupItem {...managerScope} /> },
      { label: "组说明", value: intro },
    ];
    return arr.map((val) => (
      <Descriptions.Item label={val.label} span={2}>
        {val.value}
      </Descriptions.Item>
    ));
  };

  _render() {
    const { audienceGroupLoading } = this.props;
    return (
      <WizSpin spinning={audienceGroupLoading}>
        <WizCard title="查看受众组">
          <Descriptions className="audience-group-wrp" column={1} bordered>
            {this.renderItems()}
          </Descriptions>
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { audienceGroup } = state;
  const editInfo = modelUtils.getModelEntity(
    audienceGroup,
    "audienceGroup@editInfo"
  );
  const load = modelUtils.getLoadingState(state, "audienceGroup");
  return {
    editInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(AudienceGroupPreview);
